import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionToggleLEDNodeType } from '../types';
import BaseNode from '../BaseNode';
import { getLEDText, getActionText } from '../../util/generateLEDNames';

export const ActionToggleLEDNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: ActionToggleLEDNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    const { leds, pulse, ramp } = data.options;

    const ledText = getLEDText(leds);
    const actionText = getActionText(intl, pulse, ramp, false);

    const text = `${ledText}${actionText}`;

    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Turn On/Off LED',
              id: '28El6X',
            })}
          </T>
          <T body2>{text}</T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);
